

import React, { useEffect, useMemo, useState } from "react";
import ReactEcharts from "echarts-for-react";
import 'primereact/resources/themes/lara-light-indigo/theme.css';   // theme
import 'primereact/resources/primereact.css';
import StudentCenter_bannerImg from "../../assets/images/school&center_banner.jpg"
import SchoolImg from "../../assets/images/school.png"
import TargetImg from "../../assets/images/target.png"
import CareImg from "../../assets/images/care.png"
import { useDispatch, useSelector } from "react-redux";
import {
  fetchSchool_And_Centers, fetchSchools_Centers_Report
} from '../../redux/slices/counter';
import LoaderContainer from "../../components/LoaderContainer/LoaderContainer";
import { formatNumber } from "./enrollment.component";


export default function SchoolsCenters() {
  const dispatch = useDispatch();
  const School_And_Centersdata = useSelector(state => state.netsales.School_And_Centers);
  const Schools_Centers_Reportdata = useSelector(state => state.netsales.Schools_Centers_Report);

  const appliedfilter = useSelector(state => state.filter.appliedFilters);
  const order = [
    "Elementary Schools",
    "Middle Schools",
    "High Schools",
    "Alternative and Special Schools"
  ];

  const sortedData = [...School_And_Centersdata]?.sort((a, b) => {
    return order.indexOf(a.SCHOOL_LEVEL) - order.indexOf(b.SCHOOL_LEVEL);
  });
  // loaders
  const School_And_Centersloadingdata = useSelector(state => state.netsales.School_And_Centersloading);
  const At_A_Glance_Top_Tileloadingdata = useSelector(state => state.netsales.At_A_Glance_Top_Tileloading);
  useEffect(() => {
    dispatch(fetchSchool_And_Centers({
      "elasticQueryName": "School_And_Centers",
      "filters": [{
      columnName: "SCHOOL_YEAR",
      columnValue: "2027",
      excludeKeyword: false,
    }],
      "dynamicColumns": [],
    }));
    dispatch(fetchSchools_Centers_Report({
      "elasticQueryName": "Schools_Centers_Report",
      "filters": [{
      columnName: "SCHOOL_YEAR",
      columnValue: "2027",
      excludeKeyword: false,
    }],
      "dynamicColumns": [],
    }));
  }, []);

  const [screenWidth, setScreenWidth] = useState(0);
  useEffect(() => {
    const handleResize = () => {
      if (typeof window !== 'undefined') {
        const screenWidth = window.innerWidth;
        setScreenWidth(screenWidth);
      }
    };
    window.addEventListener('resize', handleResize);
    handleResize();
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);



  const StudentCenters = {
    // tooltip: {
    //   trigger: 'item',
    //   backgroundColor: 'rgba(50,50,50,0.7)',
    //   borderColor: "#333",
    //   textStyle: {
    //     fontSize: 12,
    //     fontWeight: "normal",
    //     color: '#fff',
    //   },
    //   axisPointer: {
    //     type: 'shadow'
    //   }
    // },
    tooltip: {
      trigger: "item",
      formatter: function (params) {
        const { name, percent } = params
        return (
          `${name} : <b>${percent.toFixed(1)}%</b>`
          // params.name + " : " + params.percent.toFixed(2) + "%"
        );
      },
      confine: true
    },
    grid: {
      left: '5%',
      right: '5%',
      bottom: '10%',
      top: "0%",
      containLabel: true
    },
    legend: {
      orient: 'vertical',
      center: 'center',
      textStyle: {
        padding: [4, 20, 4, 20],
        borderRadius: 4
      },
      // right: '5%',
      left: "35%",
      itemWidth: 8.5,
      itemHeight: 6,
      bottom: -5,
      textStyle: {
        color: "#fff",
        fontSize: '11',
        fontStyle: 'normal'
      }
    },
    series: [
      {
        // name: 'Access From',
        type: 'pie',
        radius: ['30%', '60%'],
        center: ['50%', '40%'],

        avoidLabelOverlap: true,
        label: {
          show: true,
          position: 'left',
          // formatter: '{d}%',
          formatter: function (params) {
            const NumberConvert = formatNumber(params.value)
            return NumberConvert

          },
          position: 'inside',
          textStyle: {
            fontSize: 11,
            color: "#fff"
          }
        },
        // emphasis: {
        //   label: {
        //     show: true,
        //     fontSize: 10,
        //     fontWeight: 'bold'
        //   }
        // },
        labelLine: {
          show: false
        },
        data: [
          {
            value: sortedData[1]?.VALUE,
            name: sortedData[1]?.SCHOOL_LEVEL
            ,
            itemStyle:
            {
              // color: '#377ab8'
              color: '#E99F4F'
            }
          },
          {
            value: sortedData[0]?.VALUE,
            name: sortedData[0]?.SCHOOL_LEVEL
            ,
            itemStyle:
            {
              // color: '#6f2e66'
              color: '#335D76'
            }
          },
          {
            value: sortedData[2]?.VALUE,
            name: sortedData[2]?.SCHOOL_LEVEL
            ,
            itemStyle:
            {
              // color: '#2c4990'
              color: '#B55D5D'
            }
          },
          {
            value: sortedData[3]?.VALUE,
            name: sortedData[3]?.SCHOOL_LEVEL
            ,
            itemStyle:
            {
              // color: '#41a5ac'
              color: '#498E71'
            }
          },
          {
            value: sortedData[4]?.VALUE,
            name: sortedData[4]?.SCHOOL_LEVEL
            ,
            itemStyle:
            {
              // color: '#393469'
              color: '#3A3365'
            }
          },
        ]
      }
    ]
  };

  const memoizedChartOption = useMemo(() => StudentCenters, [sortedData]);


  const MyChart = React.memo(({ options }) => {
    return <ReactEcharts option={options} notMerge={true} lazyUpdate={true} style={{ maxWidth: screenWidth <= 1450 && screenWidth >= 1100 ? 300 : 360 }} />;
  });
  return (
    <div className="bg-[#0F0D0B] text-[#fff] h-[100%] rounded-[7px]">
      <div className="relative h-[190px]">
        <div className=" h-[180px] ">
          <img src={StudentCenter_bannerImg} className="h-[190px] w-full " />
        </div>
        <div className="w-full absolute bottom-0 h-[40px] bg-[#0f0d0bb3] py-2 px-3">
          <h3 className="text-[16.2px] text-[#fff]">Schools</h3>
        </div>

      </div>
      <LoaderContainer height={"70px"} width={"100%"} loading={At_A_Glance_Top_Tileloadingdata} className="mt-2 mb-2">

        <div className="grid grid-cols-2 gap-3 px-5 mt-5">
          <div className="flex items-start gap-3">
            <img src={SchoolImg} className="h-[38px] w-[38px]" />
            <div className="pt-2">
              <p className="text-[14px] text-[#ebebeb] font-light opacity-80 mb-1 whitespace-nowrap">
                Total Schools</p>
              <h4 className="text-[16px] font-semibold text-[#fff]">{Schools_Centers_Reportdata[0]?.COUNT}</h4>
            </div>
          </div>

          {/* <div className="flex items-start gap-3">
            <div className="pt-2">
              <p className="text-[9.2px] text-[#ebebeb] font-light opacity-80 mb-1">
                Distinguished schools</p>
              <h4 className="text-[20px] text-[#fff]">{Schools_Centers_Reportdata[1]?.COUNT}</h4>
            </div>
          </div> */}
        </div>
      </LoaderContainer>
      <div className="border-t border-[#ffffff26]">
        <LoaderContainer height={"272px"} width={"100%"} loading={School_And_Centersloadingdata} className="mt-5 mb-0 StudentCenters">

          <div className="mt-8 mb-0 StudentCenters">
            <MyChart options={memoizedChartOption} />

            {/* <ReactEcharts option={StudentCenters} style={{ maxWidth: screenWidth <= 1450 && screenWidth >= 1100 ? 300 : 360 }} /> */}
          </div>
        </LoaderContainer>
      </div>

      {/* <div className="grid grid-cols-2 gap-10 px-5 border-t py-3 border-[#ffffff26] mt-10">
        <div className="flex items-start gap-3">
          <img src={TargetImg} className="h-[38px] w-[38px]" />
          <div className="pt-2">
            <p className="text-[9.2px] text-[#ebebeb] font-light opacity-80 mb-1">Regular Classified People</p>
            <h4 className="text-[20px] text-[#fff]">459</h4>
          </div>
        </div>
        <div className="flex items-start gap-3">
          <img src={CareImg} className="h-[38px] w-[38px]" />
          <div className="pt-2">
            <p className="text-[9.2px] text-[#ebebeb] font-light opacity-80 mb-3">
              National Board Certified Teacher</p>
            <h4 className="text-[20px] text-[#fff]">197</h4>
          </div>
        </div>
      </div> */}
    </div>
  )
}